import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface Configuration {
	authenticationIssuerUrl: string;
	authenticationClientId: string;
	apiBaseUrl: string;
	envName: string;
	production: boolean;
}

@Injectable()
export class ConfigurationService {
	configuration: Configuration;

	constructor(private http: HttpClient) {}

	async init() {
		this.configuration = { ...(environment as Configuration) };
		try {
			//const response = await this.http.get('/env.json').toPromise();
			//console.info('loaded configuration override');
			this.configuration = { ...this.configuration }; //, ...response };
		} catch (err) {
			console.warn('unable to load env.json, skipping configuration override');
		}
	}
}
